import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

export default function TreeForm({handleTreeDetails}) {
  const treeDetails = {"tree":[]};
  const handleChange = event => {
    let tempDetail = [{
      "serial": document.getElementById('serial').value,
      "breed": document.getElementById('breed').value,
      "age": document.getElementById('age').value,
      "height": document.getElementById('height').value,
      "diameter": document.getElementById('diameter').value,
      "horizontal_line": document.getElementById('horizontal_line').value,
      "latitude": document.getElementById('latitude').value,
      "longitude": document.getElementById('longitude').value,
      "remark": document.getElementById('remark').value,
      "image":""
    }];
    treeDetails.tree = tempDetail;
    //console.log(tempDetail);
    handleTreeDetails(tempDetail);
  }
  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Tree Details
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            required
            id="serial"
            name="serial"
            label="Serial"
            fullWidth
            autoComplete="serial"
            onChange = {handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="breed"
            name="breed"
            label="Breed"
            fullWidth
            autoComplete="breed"
            onChange = {handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="age"
            name="age"
            label="age"
            fullWidth
            autoComplete="age"
            onChange = {handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="height"
            name="height"
            label="Height"
            fullWidth
            autoComplete="height"
            onChange = {handleChange}

          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="diameter"
            name="diameter"
            label="Diameter"
            fullWidth
            autoComplete="diameter"
            onChange = {handleChange}

          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="horizontal_line"
            name="horizontal_line"
            label="Horizontal Line"
            fullWidth
            autoComplete="horizontal_line"
            onChange = {handleChange}

          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            required
            id="latitude"
            name="latitude"
            label="Latitude"
            fullWidth
            autoComplete="latitude"
            onChange = {handleChange}

          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField 
            required id="longitude" 
            name="longitude" 
            label="Longitude" 
            fullWidth 
            onChange = {handleChange}

            />
        </Grid>
        <Grid item xs={12}>
          <TextField
            required
            id="remark"
            name="remark"
            label="Remark"
            fullWidth
            autoComplete="remark"
            onChange = {handleChange}

          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

// TreeForm.propTypes = {
//   treeDetails: PropTypes.func
// };

// TreeForm.defaultProps = {
//   treeDetails: (data) => {}
// };